import { trackAction } from './ab_track';
import { initRebuildCompanyArchiveFitHeading } from './rebuild_company_archive_fit_heading';
import { initBottomCvArea } from './ui/bottom_cv_area';
import { initSmoothAnchorLinks } from './ui/smooth_anchor_links';
import { initRebuildCompanyArchiveAreaContext } from './rebuild_company_area_context';

const SIDEBAR_FORM_FIELD_NAMES = {
  'kind-reform[]': 'building_type',
  'client[prefecture_id]': 'prefecture',
  'client[budget_id]': 'budget',
};

function initRebuildCompanyArchiveTracking() {
  // documentへの委譲リスナーのため、再初期化時の多重登録を防ぐ
  if (document.documentElement.dataset.rebuildCompanyArchiveTrackingInitialized === 'true') return;
  document.documentElement.dataset.rebuildCompanyArchiveTrackingInitialized = 'true';

  // sendBeacon なので LP への遷移と競合せずに送信が完了する
  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (!event.target.closest('#sidebar-fixed-form')) return;

    trackAction('sidebar_form_submitted');
  });

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!select.closest('#sidebar-fixed-form')) return;
    if (select.value === '') return;

    trackAction('sidebar_form_field_selected', {
      field: SIDEBAR_FORM_FIELD_NAMES[select.name] || select.name,
      value: select.value,
      label: select.selectedOptions[0]?.textContent?.trim() ?? '',
    });
  });
}

function initArchiveInteractions() {
  if (document.documentElement.dataset.rebuildCompanyArchiveInteractionsInitialized === 'true') return;
  document.documentElement.dataset.rebuildCompanyArchiveInteractionsInitialized = 'true';

  initBottomCvArea();
  initSmoothAnchorLinks();
  initRebuildCompanyArchiveFitHeading();
  initRebuildCompanyArchiveTracking();
  initRebuildCompanyArchiveAreaContext();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArchiveInteractions);
} else {
  initArchiveInteractions();
}
